var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdiFileDownloadOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.33334L20 8.33334V20.3333C20 20.8638 19.7893 21.3725 19.4142 21.7476C19.0391 22.1226 18.5304 22.3333 18 22.3333H6C5.46957 22.3333 4.96086 22.1226 4.58579 21.7476C4.21071 21.3725 4 20.8638 4 20.3333V4.33334C4 3.80291 4.21071 3.2942 4.58579 2.91913C4.96086 2.54406 5.46957 2.33334 6 2.33334H14ZM18 20.3333V9.33334H13V4.33334H6V20.3333H18ZM12 19.3333L8 15.3333H10.5V12.3333H13.5V15.3333H16L12 19.3333Z",
    fill: "#84BE08"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiFileDownloadOutline);
export default __webpack_public_path__ + "static/media/mdi_file-download-outline.9d6fe956dc0ff58bd97d3822c995e746.svg";
export { ForwardRef as ReactComponent };